import React, { useState, useRef } from "react";
import styles from "../InputFields/formlabels.module.scss";

interface BaseInputProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  type?: string;
  placeholder?: string;
  className?: string;
  useFloatingLabel?: boolean;
}

export default function BaseInput({
  value,
  onChange,
  label,
  type = "text",
  placeholder,
  className,
  useFloatingLabel = true
}: BaseInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [text, setText] = useState<string>(value);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    onChange(newValue);
    setText(newValue);
  };

  const handleLabelClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  if (useFloatingLabel) {
    return (
      <div>
        <div className={styles.box}>
          <input
            ref={inputRef}
            placeholder=""
            type={type}
            className={styles.input}
            value={value}
            onChange={handleChange}
          />
          <label
            htmlFor={label.toLowerCase()}
            className={styles.label}
            onClick={handleLabelClick}
            style={text !== "" ? {top:"-5px", fontSize:"11px", color: "#2e79f1"}:{}}
          >
            {label}
          </label>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className={className || ""}>
        <input
          placeholder={placeholder || label}
          type={type}
          className="search_input1"
          value={value}
          onChange={handleChange}
        />
      </div>
    </div>
  );
} 